import { render, staticRenderFns } from "./EditPPage.vue?vue&type=template&id=26ad6bb8&scoped=true&"
import script from "./EditPPage.vue?vue&type=script&lang=js&"
export * from "./EditPPage.vue?vue&type=script&lang=js&"
import style0 from "./EditPPage.vue?vue&type=style&index=0&id=26ad6bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ad6bb8",
  null
  
)

export default component.exports